import React from 'react'
import PropTypes from 'prop-types'
import { Field, getIn } from 'formik'
import classNames from 'classnames'

import { FormGroup } from '@peracto/peracto-ui'

const Textarea = ({
    name,
    label,
    help,
    tooltip,
    className,
    showWhen,
    charactercount,
    testId,
    ...props
}) => {
    return (
        <Field name={name}>
            {({ field, form }) => {
                let error = getIn(form.errors, name)

                if (error) {
                    const errorFieldName = label ? label : 'This'
                    error = error.replace(field.name, errorFieldName)
                }

                if (showWhen) {
                    const showField = form.values.hasOwnProperty(showWhen)
                        ? form.values[showWhen]
                        : false

                    if (!showField) {
                        return null
                    }
                }

                props.className = classNames('form-control', className)

                if (help) {
                    props['aria-describedby'] = `${name}Help`
                }

                if (!field.value) field.value = '' // Prevent uncontrolled input error

                return (
                    <FormGroup
                        {...{ name, label, help, tooltip }}
                        charactercount={charactercount}
                        error={error}
                    >
                        <textarea
                            {...props}
                            {...field}
                            disabled={form.isSubmitting || props.disabled}
                            data-testid={testId}
                        ></textarea>
                    </FormGroup>
                )
            }}
        </Field>
    )
}

Textarea.displayName = 'Textarea'

Textarea.propTypes = {
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    placeholder: PropTypes.string,
    className: PropTypes.string,
}

export default Textarea
